// extracted by mini-css-extract-plugin
export default {"bannerContainer":"styles_bannerContainer__WAoNT","bannerTitle":"styles_bannerTitle__Khj+z","bannerSubtitle":"styles_bannerSubtitle__QAjWu","bannerLink":"styles_bannerLink__19spP"};